import React from "react";
import styled from "styled-components";
import type { AuthClient } from "./clients-types";

const Badge = styled.span<{ $variant: "active" | "blocked" | "deleted" }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  background-color: ${(p) =>
    p.$variant === "active"
      ? "#e8f5e9"
      : p.$variant === "blocked"
      ? "#fff3e0"
      : "#ffebee"};
  color: ${(p) =>
    p.$variant === "active"
      ? "#2e7d32"
      : p.$variant === "blocked"
      ? "#e65100"
      : "#c62828"};
`;

export function getClientStatus(client: AuthClient): "active" | "blocked" | "deleted" {
  if (client.deleted_at) return "deleted";
  if (client.blocked_at) return "blocked";
  return "active";
}

const labels: Record<string, string> = {
  active: "Активен",
  blocked: "Заблокирован",
  deleted: "Удалён",
};

interface Props {
  client: AuthClient;
}

export const ClientStatusBadge: React.FC<Props> = ({ client }) => {
  const status = getClientStatus(client);
  return <Badge $variant={status}>{labels[status]}</Badge>;
};
